import React from 'react';
import { useClassName } from 'common/hooks';
import { ContentfulRichText } from 'common/components';
import HomepageImage from 'public/screens/Home/Components/Image';
import './card.less';
import './card-n.less';

export default function CardTypeN({ item }) {
  const classNames = useClassName('CLPCardTypeN');
  return (
    <div className={classNames('container')}>
      <h2>{item.fields.title}</h2>
      <section>
        <ContentfulRichText field={{ 'en-US': item.fields.description }} />
      </section>
      <div className={classNames('footer')}>
        {item?.fields?.labels && (
          <div className="labels">
            {item?.fields?.labels[0] && (
              <span className="label-1">{item.fields.labels[0]}</span>
            )}
            {item?.fields?.labels[1] && (
              <span className="label-2">{item.fields.labels[1]}</span>
            )}
          </div>
        )}
        {item.fields.icon && <HomepageImage field={item.fields.icon} />}
      </div>
    </div>
  );
}
